<script>
export default {
  name: "breadcrumbSection",
  data() {
    return {};
  },
  props: {
    propsAddress: String,
    propsSuburb: String
  }
};
</script>

<template>
  <el-row style="padding: 8px 16px 8px 16px; background-color: #2D2D2D">
    <el-col :span="24">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item :to="{ path: '/homepage' }"
          >Home</el-breadcrumb-item
        >
        <el-breadcrumb-item>{{ propsSuburb }}</el-breadcrumb-item>
        <el-breadcrumb-item>{{ propsAddress }}</el-breadcrumb-item>
      </el-breadcrumb>
    </el-col>
  </el-row>
</template>

<style scoped>
.el-breadcrumb__item /deep/ .el-breadcrumb__separator {
  color: #fff;
  font-weight: 600;
}

.el-breadcrumb__item /deep/ .el-breadcrumb__inner {
  color: #fff;
  font-feature-settings: "clig" off, "liga" off;
  font-family: Metropolis;
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: 12px;
}
</style>



// WEBPACK FOOTER //
// src/components/package/breadcrumbSection.vue